module.exports = __webpack_public_path__ + "img/workout-notebook_B095LFLMGK.a965c2fd.jpg";